import React from "react";
import Grid from "@mui/material/Grid";
import Profile from "../../../../assets/images/user1.png";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { style } from "./style";
import { ReactComponent as Sheet } from "../../../../assets/ViewLeave-images/material-symbols_receipt-outline.svg";
import { ReactComponent as Calender } from "../../../../assets/ViewLeave-images/Vector (1).svg";
import { ReactComponent as Hastag } from "../../../../assets/ViewLeave-images/ph_hash-bold.svg";
import { ReactComponent as Info } from "../../../../assets/ViewLeave-images/material-symbols_info-outline.svg";
import { formatDate } from "../../../../utils/DateFormat";

const ViewCommissionPage = ({ item }) => {

  return (
    <>

      <Grid container sx={{ display: "flex", p: "25px", justifyContent: "space-between" }}>
        <Grid item xs={12} lg={7.4} sx={style.gridbioBox}>
          <Box sx={style.upperContainer}>
            <Box sx={style.profileBox}>
              <Box>
                <Avatar alt="profile" src={item?.image} sx={style.avatar} />
              </Box>
              <Box>
                <Typography variant="h4" sx={style.employeeName}>{item?.fullName}</Typography>
                <Typography variant="p" sx={style.textPrimary}>{item?.employeeDetails?.personalInfo?.firstName} {item?.employeeDetails?.personalInfo?.surName}</Typography>
                <Typography variant="body1" sx={style.employeeId}>{`Employee Email: ${item?.employeeDetails?.personalInfo?.email}`}</Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={style.infooBox}>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Sheet />
                <Typography variant="body1" sx={style.bioIconText}>
                  Commission Name
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.name}
                </Typography>

              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Calender />
                <Typography variant="body1" sx={style.bioIconText}>
                  Start Date
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {formatDate(item?.start)}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Calender />
                <Typography variant="body1" sx={style.bioIconText}>
                  End Date
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {formatDate(item?.end)}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Hastag />

                <Typography variant="body1" sx={style.bioIconText}>
                  Commission Amount
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.rate}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Info />

                <Typography variant="body1" sx={style.bioIconText}>
                  Status
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.status}
                </Typography>
              </Box>
            </Box>
            {/* <Box sx={style.mainBioBox}>
              <Box sx={style.iconText}>
                <Reason />

                <Typography variant="body1" sx={style.bioIconText}>
                  Reason
                </Typography>
              </Box>
              <Box sx={style.iconRight}>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.reason}
                </Typography>
              </Box>
            </Box> */}
            {/* {permissionEdit  ?
              <FormControlLabel  control={<Checkbox />} onChange={(e) => setIspaid(e.target.checked)} label="Is Paid" />
              :null}   */}
          </Box>
        </Grid>

        <Grid item xs={12} lg={4.3} sx={{ mt: { xs: 3, lg: 0 } }}>
          <Grid sx={style.gridInfoBox}>
            <Typography sx={style.boxHeading}>Total Commission</Typography>
            <Box sx={style.infoBox}>

              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  Approved Commission
                </Typography>
                {/* <Typography variant="body1" sx={style.bioText}>
                  Approved Commission
                </Typography> */}
                {/* <Typography variant="body1" sx={style.bioText}>
                  Balance after booked leave
                </Typography> */}
              </Box>
              <Box>
                {/* <Typography variant="body1" sx={style.bioText}>
                  {leave?.totalLeaveBalance?.remainingLeaveBalance}
                </Typography> */}
                <Typography variant="body1" sx={style.bioText}>
                  {item?.rate}
                </Typography>
                {/* <Typography variant="body1" sx={style.bioText}>
                  {leave?.totalLeaveBalance?.balanceAfterBookedLeave}
                </Typography> */}
              </Box>

            </Box>
          </Grid>
          {/* <Grid sx={style.gridInfoBox}>
            <Typography sx={style.boxHeading}>Leave This Month</Typography>
            <Box sx={style.infoBox}>

              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  Total applied
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  Approved leaves
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  Rejected leaves
                </Typography>
              </Box>
              <Box>
                <Typography sx={style.bioText}>
                  {leave?.leavesByMonth?.totalApplied}
                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  {leave?.leavesByMonth?.approvedLeaves}

                </Typography>
                <Typography variant="body1" sx={style.bioText}>
                  {leave?.leavesByMonth?.rejectedLeaves}

                </Typography>
              </Box>

            </Box>
           
          </Grid> */}

        </Grid>



      </Grid >


    </>
  )
}
export default ViewCommissionPage;
